import { InfluencerListView } from './view/InfluencerList.view';
import { useInfluencerListViewModel } from './view-model/InfluencerList.viewModel';

export const InfluencerListNewPage = () => {
  const vm = useInfluencerListViewModel();

  return <InfluencerListView {...vm.value} />;
};
